import { SITE_CONFIG } from '../siteConfig.js';

const STORAGE_KEY = 'yolo-pricing-customer-id';
const ADMIN_TOKEN_KEY = 'yolo-admin-token';
const ADMIN_JWT_KEY = 'yolo-admin-jwt';

export const getPricingCustomerId = (): string | undefined => {
  const envValue = SITE_CONFIG.pricing?.customerId?.trim();
  if (typeof window === 'undefined') {
    return envValue || undefined;
  }

  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored?.trim() || envValue || undefined;
};

export const setPricingCustomerId = (value?: string): void => {
  if (typeof window === 'undefined') return;
  if (value && value.trim().length > 0) {
    window.localStorage.setItem(STORAGE_KEY, value.trim());
  } else {
    window.localStorage.removeItem(STORAGE_KEY);
  }
};

export const getAdminToken = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  const stored = window.localStorage.getItem(ADMIN_TOKEN_KEY);
  return stored?.trim() || undefined;
};

export const setAdminToken = (value?: string): void => {
  if (typeof window === 'undefined') return;
  if (value && value.trim().length > 0) {
    window.localStorage.setItem(ADMIN_TOKEN_KEY, value.trim());
  } else {
    window.localStorage.removeItem(ADMIN_TOKEN_KEY);
  }
};

export const getAdminJwt = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  const stored = window.localStorage.getItem(ADMIN_JWT_KEY);
  return stored?.trim() || undefined;
};

export const setAdminJwt = (value?: string): void => {
  if (typeof window === 'undefined') return;
  if (value && value.trim().length > 0) {
    window.localStorage.setItem(ADMIN_JWT_KEY, value.trim());
  } else {
    window.localStorage.removeItem(ADMIN_JWT_KEY);
  }
};
